module.exports = __webpack_public_path__ + "media/woodpacking_notification.f564b5f1.mp3";